<template>
	<div class="survey-final container container-full-height min">
		<Nav />
		<span class="overlay" :class="{active: isMenuOpen}"></span>
		<div class="header header-standard">
			<HeaderNavBar survey />
		</div><!-- header -->
		<div class="header-image lblue"></div><!-- header image -->
		<div class="content-container">
			<img class="survey-man-img" alt="The Mission to Seafarers" src="@/assets/survey-man.png" />
			<div class="final-result-wrap">
				<div class="intro">
					<span class="sub">Your Result</span>
					<div class="score-card-total">
						<span class="score-card-result">{{ parseFloat(result.score) }}</span>
						<span class="score-card-total-max">/ 10</span>
					</div>
					<p v-if="result.score >= 6"><strong>{{ !result.anonymous && result.first_name ? result.first_name + ', i' : 'I' }}t’s great to hear that you are feeling positive about life at sea!</strong></p>
                    <p v-else><strong>{{ !result.anonymous && result.first_name ? result.first_name + ', w' : 'W' }}e are sorry to see that you feel that way and that things are difficult. Please find contact details below for access to advice and support.</strong></p>
					<p>Remember to take our survey regularly so that you can compare your results and gain access to helpful advice.</p>
				</div>
			</div>
			<div class="button-wrap" style="margin-bottom: 100px; position: relative;">
				<!-- <Button class="btn btn-large btn-lightblue" text="Submit Survey"></Button> -->
				<Button class="btn btn-large btn-white" text="View result summary" @click.native="$router.push({ name: 'SurveyResult', params: { id: result.uuid } })"></Button>
			</div>
		</div>
		<Menu />
	</div>
</template>
<script>
	import HeaderNavBar from '@/components/HeaderNavBar.vue';
	import Nav from '@/components/Nav.vue';
	import Menu from '@/components/Menu.vue';
    import Button from '@/components/Button.vue';
    import SurveyService from '@/services/SurveyService';
	export default {
		name: 'SurveyTakeFinalResult',
		components: {
			Nav,
			HeaderNavBar,
			Menu,
			Button
		},
		data () {
	        return {
                result: {},
                modalUpdateDetailsHeight: '-588',
                showUpdateDetailsModal: true
	        };
	    },
	    methods: {
	    	getSurveyResult () {
                return SurveyService.getResult(this.surveyId).then((response) => {
                    this.result = response.data.result;
                }).finally(() => {
                    this.$store.commit('RESET_SURVEY_ID');
                });
            }
	    },
	    computed: {
			isMenuOpen () {
	            return this.$store.state.isMenuOpen;
	        },
            surveyId () {
                return this.$store.state.surveyId;
            }
		},
		mounted () {
            if (!this.surveyId) {
                this.$router.push('/seafarers-happiness-index');
            }
            this.getSurveyResult();
        }
	};
</script>
<style scoped lang="scss">
	@import "@/assets/scss/_variables.scss";
	@mixin max_width($breakpoint) {
	    @media only screen and (max-width: $breakpoint) { @content; }
	}
	.survey-man-img {
		z-index: 0;
		position: absolute;
		width: 196px;
		bottom: 0;
		right: 0;
	}
	.content-container {
		background: #44C8F5;
		padding: 0 28px;
		display: flex;
		flex: auto;
	    flex-direction: column;
	    justify-content: space-between;
	}
	.final-result-wrap {
		text-align: center;
		position: relative;
		.sub {
			font-size: 14px;
			color: #FFFFFF;
			letter-spacing: -0.41px;
			line-height: 19px;
			margin-bottom: 35px;
			display: block;
			position: relative;
		}
		p {
			color: $white;
			max-width: 300px;
			width: 100%;
			margin: 0 auto 15px;
			strong {
				color: $white;
			}
		}
	}
	.score-card-total {
		font-weight: 600;
		color: #FFFFFF;
		font-size: 70px;
		letter-spacing: -2.06px;
		line-height: 24px;
		margin: 12px 0 20px;
		.score-card-total-max {
			font-size: 45px;
			letter-spacing: -1.32px;
			line-height: 55px;
			opacity: 0.7;
			margin-left: 12px;
		}
	}
</style>
